// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3358cfa8","455":"c89a5197"}[chunkId] + ".chunk.js";
};